
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as QGpzLWpvZGEvdGltZXpvbmU from '@js-joda/timezone';
import * as YWFhLWtpbHVhLWFzc2V0cy9ub2RlanNfZG9tLm1qcw from 'aaa-kilua-assets/nodejs_dom.mjs';
import * as d2FzbTpqcy1zdHJpbmc from './freiham365-composeApp.js-builtins.mjs';
import * as enp6LWtpbHVhLWFzc2V0cy9rLXN0eWxlLmNzcw from 'zzz-kilua-assets/k-style.css';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_QGpzLWpvZGEvdGltZXpvbmU_ = QGpzLWpvZGEvdGltZXpvbmU;
const _ref_YWFhLWtpbHVhLWFzc2V0cy9ub2RlanNfZG9tLm1qcw_ = YWFhLWtpbHVhLWFzc2V0cy9ub2RlanNfZG9tLm1qcw;
const _ref_enp6LWtpbHVhLWFzc2V0cy9rLXN0eWxlLmNzcw_ = enp6LWtpbHVhLWFzc2V0cy9rLXN0eWxlLmNzcw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'js.objects.unsafeJso' : () => ({}),
    'js.reflect.unsafeCast' : (value) => value,
    'kotlin.js.undefined_$external_prop_getter' : () => undefined,
    'js.intl.DateTimeFormat_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Intl.DateTimeFormat(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'js.intl.resolvedOptions_$external_fun' : (_this, ) => _this.resolvedOptions(),
    'js.intl.toLocaleString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleString(p0, isDefault0 ? undefined : p1, ),
    'js.intl.locale_$external_prop_getter' : (_this) => _this.locale,
    'js.array.get_$external_fun' : (_this, i) => _this[i],
    'js.numbers.JsNumber_$external_fun' : (p0) => new Number(p0),
    'js.numbers.JsNumber_$external_fun_1' : (p0) => new Number(p0),
    'js.promise.then_$external_fun' : (_this, p0) => _this.then(p0),
    'js.promise.resolve_$external_fun' : (_this, p0) => _this.resolve(p0),
    'js.promise.Companion_$external_object_getInstance' : () => Promise,
    'js.reflect.set_$external_fun' : (_this, p0, p1, p2) => _this.set(p0, p1, p2),
    'js.reflect.Reflect_$external_object_getInstance' : () => Reflect,
    'web.abort.AbortController_$external_fun' : () => new AbortController(),
    'web.abort.signal_$external_prop_getter' : (_this) => _this.signal,
    'web.abort.abort_$external_fun' : (_this, p0, isDefault0) => _this.abort(isDefault0 ? undefined : p0, ),
    'web.abort.AbortController_$external_class_instanceof' : (x) => x instanceof AbortController,
    'web.abort.AbortController_$external_class_get' : () => AbortController,
    'web.console.log_$external_fun' : (_this, p0) => _this.log(...p0),
    'web.console.console_$external_prop_getter' : () => console,
    'web.events.currentTarget_$external_prop_getter' : (_this) => _this.currentTarget,
    'web.events.target_$external_prop_getter' : (_this) => _this.target,
    'web.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'web.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
    'web.navigator.language_$external_prop_getter' : (_this) => _this.language,
    'web.events.addEventListener_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.addEventListener(p0, p1, isDefault0 ? undefined : p2, ),
    'web.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2, isDefault0) => _this.addEventListener(p0, p1, isDefault0 ? undefined : p2, ),
    'web.events.removeEventListener_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.removeEventListener(p0, p1, isDefault0 ? undefined : p2, ),
    'web.animations.requestAnimationFrame_$external_fun' : (p0) => requestAnimationFrame(p0),
    'web.cssom.removeProperty_$external_fun' : (_this, p0) => _this.removeProperty(p0),
    'web.cssom.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'web.cssom.alignContent_$external_prop_setter' : (_this, v) => _this.alignContent = v,
    'web.cssom.alignItems_$external_prop_setter' : (_this, v) => _this.alignItems = v,
    'web.cssom.alignSelf_$external_prop_setter' : (_this, v) => _this.alignSelf = v,
    'web.cssom.background_$external_prop_setter' : (_this, v) => _this.background = v,
    'web.cssom.border_$external_prop_setter' : (_this, v) => _this.border = v,
    'web.cssom.borderBottom_$external_prop_setter' : (_this, v) => _this.borderBottom = v,
    'web.cssom.borderLeft_$external_prop_setter' : (_this, v) => _this.borderLeft = v,
    'web.cssom.borderRadius_$external_prop_setter' : (_this, v) => _this.borderRadius = v,
    'web.cssom.borderRight_$external_prop_setter' : (_this, v) => _this.borderRight = v,
    'web.cssom.borderTop_$external_prop_setter' : (_this, v) => _this.borderTop = v,
    'web.cssom.bottom_$external_prop_setter' : (_this, v) => _this.bottom = v,
    'web.cssom.boxShadow_$external_prop_setter' : (_this, v) => _this.boxShadow = v,
    'web.cssom.clear_$external_prop_setter' : (_this, v) => _this.clear = v,
    'web.cssom.color_$external_prop_setter' : (_this, v) => _this.color = v,
    'web.cssom.cssFloat_$external_prop_setter' : (_this, v) => _this.cssFloat = v,
    'web.cssom.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'web.cssom.direction_$external_prop_setter' : (_this, v) => _this.direction = v,
    'web.cssom.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'web.cssom.flexBasis_$external_prop_setter' : (_this, v) => _this.flexBasis = v,
    'web.cssom.flexDirection_$external_prop_setter' : (_this, v) => _this.flexDirection = v,
    'web.cssom.flexGrow_$external_prop_setter' : (_this, v) => _this.flexGrow = v,
    'web.cssom.flexShrink_$external_prop_setter' : (_this, v) => _this.flexShrink = v,
    'web.cssom.flexWrap_$external_prop_setter' : (_this, v) => _this.flexWrap = v,
    'web.cssom.fontFamily_$external_prop_setter' : (_this, v) => _this.fontFamily = v,
    'web.cssom.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'web.cssom.fontStyle_$external_prop_setter' : (_this, v) => _this.fontStyle = v,
    'web.cssom.fontVariant_$external_prop_setter' : (_this, v) => _this.fontVariant = v,
    'web.cssom.fontWeight_$external_prop_setter' : (_this, v) => _this.fontWeight = v,
    'web.cssom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'web.cssom.justifyContent_$external_prop_setter' : (_this, v) => _this.justifyContent = v,
    'web.cssom.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'web.cssom.letterSpacing_$external_prop_setter' : (_this, v) => _this.letterSpacing = v,
    'web.cssom.lineBreak_$external_prop_setter' : (_this, v) => _this.lineBreak = v,
    'web.cssom.lineHeight_$external_prop_setter' : (_this, v) => _this.lineHeight = v,
    'web.cssom.listStyle_$external_prop_setter' : (_this, v) => _this.listStyle = v,
    'web.cssom.margin_$external_prop_setter' : (_this, v) => _this.margin = v,
    'web.cssom.marginBottom_$external_prop_setter' : (_this, v) => _this.marginBottom = v,
    'web.cssom.marginLeft_$external_prop_setter' : (_this, v) => _this.marginLeft = v,
    'web.cssom.marginRight_$external_prop_setter' : (_this, v) => _this.marginRight = v,
    'web.cssom.marginTop_$external_prop_setter' : (_this, v) => _this.marginTop = v,
    'web.cssom.maxHeight_$external_prop_setter' : (_this, v) => _this.maxHeight = v,
    'web.cssom.maxWidth_$external_prop_setter' : (_this, v) => _this.maxWidth = v,
    'web.cssom.minHeight_$external_prop_setter' : (_this, v) => _this.minHeight = v,
    'web.cssom.minWidth_$external_prop_setter' : (_this, v) => _this.minWidth = v,
    'web.cssom.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'web.cssom.order_$external_prop_setter' : (_this, v) => _this.order = v,
    'web.cssom.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'web.cssom.overflowWrap_$external_prop_setter' : (_this, v) => _this.overflowWrap = v,
    'web.cssom.overflowX_$external_prop_setter' : (_this, v) => _this.overflowX = v,
    'web.cssom.overflowY_$external_prop_setter' : (_this, v) => _this.overflowY = v,
    'web.cssom.padding_$external_prop_setter' : (_this, v) => _this.padding = v,
    'web.cssom.paddingBottom_$external_prop_setter' : (_this, v) => _this.paddingBottom = v,
    'web.cssom.paddingLeft_$external_prop_setter' : (_this, v) => _this.paddingLeft = v,
    'web.cssom.paddingRight_$external_prop_setter' : (_this, v) => _this.paddingRight = v,
    'web.cssom.paddingTop_$external_prop_setter' : (_this, v) => _this.paddingTop = v,
    'web.cssom.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'web.cssom.resize_$external_prop_setter' : (_this, v) => _this.resize = v,
    'web.cssom.right_$external_prop_setter' : (_this, v) => _this.right = v,
    'web.cssom.textAlign_$external_prop_setter' : (_this, v) => _this.textAlign = v,
    'web.cssom.textDecoration_$external_prop_setter' : (_this, v) => _this.textDecoration = v,
    'web.cssom.textIndent_$external_prop_setter' : (_this, v) => _this.textIndent = v,
    'web.cssom.textOverflow_$external_prop_setter' : (_this, v) => _this.textOverflow = v,
    'web.cssom.textShadow_$external_prop_setter' : (_this, v) => _this.textShadow = v,
    'web.cssom.textTransform_$external_prop_setter' : (_this, v) => _this.textTransform = v,
    'web.cssom.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'web.cssom.transition_$external_prop_setter' : (_this, v) => _this.transition = v,
    'web.cssom.unicodeBidi_$external_prop_setter' : (_this, v) => _this.unicodeBidi = v,
    'web.cssom.verticalAlign_$external_prop_setter' : (_this, v) => _this.verticalAlign = v,
    'web.cssom.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
    'web.cssom.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'web.cssom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'web.cssom.wordBreak_$external_prop_setter' : (_this, v) => _this.wordBreak = v,
    'web.cssom.wordSpacing_$external_prop_setter' : (_this, v) => _this.wordSpacing = v,
    'web.cssom.zIndex_$external_prop_setter' : (_this, v) => _this.zIndex = v,
    'web.cssom.style_$external_prop_getter' : (_this) => _this.style,
    'web.cssom.matches_$external_prop_getter' : (_this) => _this.matches,
    'web.cssom.matchMedia_$external_fun' : (p0) => matchMedia(p0),
    'web.dom.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'web.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'web.dom.body_$external_prop_getter' : (_this) => _this.body,
    'web.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'web.dom.createElementNS_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.createElementNS(p0, p1, isDefault0 ? undefined : p2, ),
    'web.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
    'web.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'web.dom.getElementsByTagName_$external_fun' : (_this, p0) => _this.getElementsByTagName(p0),
    'web.dom.className_$external_prop_setter' : (_this, v) => _this.className = v,
    'web.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'web.dom.innerHTML_$external_prop_setter' : (_this, v) => _this.innerHTML = v,
    'web.dom.scrollTop_$external_prop_setter' : (_this, v) => _this.scrollTop = v,
    'web.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'web.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'web.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'web.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'web.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'web.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'web.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'web.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'web.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'web.dom.Text_$external_class_instanceof' : (x) => x instanceof Text,
    'web.dom.Text_$external_class_get' : () => Text,
    'web.dom.document_$external_prop_getter' : () => document,
    'web.html.download_$external_prop_setter' : (_this, v) => _this.download = v,
    'web.html.disabled_$external_prop_setter' : (_this, v) => _this.disabled = v,
    'web.html.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'web.html.length_$external_prop_getter' : (_this) => _this.length,
    'web.html.item_$external_fun' : (_this, p0) => _this.item(p0),
    'web.html.accessKey_$external_prop_setter' : (_this, v) => _this.accessKey = v,
    'web.html.draggable_$external_prop_setter' : (_this, v) => _this.draggable = v,
    'web.html.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'web.html.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'web.html.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'web.html.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'web.html.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'web.html.srcdoc_$external_prop_setter' : (_this, v) => _this.srcdoc = v,
    'web.html.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'web.html.alt_$external_prop_setter' : (_this, v) => _this.alt = v,
    'web.html.src_$external_prop_setter_1' : (_this, v) => _this.src = v,
    'web.intersection.IntersectionObserver_$external_fun' : (p0, p1, isDefault0) => new IntersectionObserver(p0, isDefault0 ? undefined : p1, ),
    'web.intersection.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'web.intersection.disconnect_$external_fun' : (_this, ) => _this.disconnect(),
    'web.intersection.observe_$external_fun' : (_this, p0) => _this.observe(p0),
    'web.intersection.isIntersecting_$external_prop_getter' : (_this) => _this.isIntersecting,
    'web.intersection.IntersectionObserverEntry_$external_class_instanceof' : (x) => x instanceof IntersectionObserverEntry,
    'web.intersection.IntersectionObserverEntry_$external_class_get' : () => IntersectionObserverEntry,
    'web.location.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'web.location.search_$external_prop_getter' : (_this) => _this.search,
    'web.location.reload_$external_fun' : (_this, ) => _this.reload(),
    'web.mouse.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'web.mouse.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'web.mouse.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'web.mouse.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'web.navigator.navigator_$external_prop_getter' : () => navigator,
    'web.window.innerWidth_$external_prop_getter' : (_this) => _this.innerWidth,
    'web.window.location_$external_prop_getter' : (_this) => _this.location,
    'web.window.onpopstate_$external_prop_setter' : (_this, v) => _this.onpopstate = v,
    'web.window.window_$external_prop_getter' : () => window,
    'dev.kilua.CoreCss_$external_object_getInstance' : () => _ref_enp6LWtpbHVhLWFzc2V0cy9rLXN0eWxlLmNzcw_,
    'dev.kilua.data_$external_prop_getter' : (_this) => _this.data,
    'dev.kilua.accept_$external_fun' : (_this, ) => _this.accept(),
    'dev.kilua.dispose_$external_fun' : (_this, p0) => _this.dispose(p0),
    'dev.kilua.appState_$external_prop_getter' : (_this) => _this.appState,
    'dev.kilua.appState_$external_prop_setter' : (_this, v) => _this.appState = v,
    'dev.kilua.externals.nodeJsCreateElement_$external_fun' : () => _ref_YWFhLWtpbHVhLWFzc2V0cy9ub2RlanNfZG9tLm1qcw_.nodeJsCreateElement(),
    'dev.kilua.externals.nodeJsCreateText_$external_fun' : () => _ref_YWFhLWtpbHVhLWFzc2V0cy9ub2RlanNfZG9tLm1qcw_.nodeJsCreateText(),
    'dev.kilua.utils.isDom' : () => typeof document !== 'undefined' && typeof document.kilua == 'undefined',
    'de.keesolutions.kcx.ui.primitives.jsScrollElementToPixel' : (id, px) => {
        var el = document.getElementById(id);
        if (el) el.scrollTo({ left: px, behavior: 'smooth' });
    },
    'de.keesolutions.kcx.ui.primitives.jsAttachRowWheelScroll' : (el, decide) => {
        var handler = function(e) {
            if (e.defaultPrevented) return;
            var next = decide(e.deltaX, e.deltaY, e.deltaMode, e.shiftKey || e.ctrlKey || e.metaKey || e.altKey,
                el.scrollLeft, el.scrollWidth, el.clientWidth, window.getComputedStyle(el).direction === 'rtl');
            if (next !== next) return;
            el.scrollLeft = next;
            e.preventDefault();
        };
        el.addEventListener('wheel', handler, { passive: false });
        return function() { el.removeEventListener('wheel', handler); };
    },
    'de.keesolutions.kcx.ui.primitives.__convertKotlinClosureToJsClosure_8' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2, p3, p4, p5, p6, p7) => trampoline(f, p0, p1, p2, p3, p4, p5, p6, p7)),
    'de.keesolutions.kcx.ui.primitives.jsRun' : (fn) => { fn(); },
    'de.keesolutions.kcx.ui.primitives.jsAttachRowDragScroll' : (el) => {
        var down = null;
        var dragging = false;
        var swallowClick = false;
        var overflows = function() { return el.scrollWidth - el.clientWidth > 1; };
        var restCursor = function() { el.style.cursor = overflows() ? 'grab' : ''; };
        var end = function() {
            if (dragging) {
                swallowClick = true;
                el.style.userSelect = '';
                try { el.releasePointerCapture(down.id); } catch (err) {}
                restCursor();
            }
            down = null;
            dragging = false;
        };
        var onEnter = function(e) { if (e.pointerType === 'mouse' && !dragging) restCursor(); };
        var onDown = function(e) {
            swallowClick = false;
            dragging = false;
            down = e.pointerType === 'mouse' && e.button === 0 && overflows()
                ? { id: e.pointerId, x: e.clientX, left: el.scrollLeft } : null;
        };
        var onMove = function(e) {
            if (!down || e.pointerId !== down.id) return;
            if ((e.buttons & 1) === 0) { end(); return; }
            var dx = e.clientX - down.x;
            if (!dragging) {
                if (Math.abs(dx) <= 5) return;
                var t = e.target;
                if (t !== el && t.hasPointerCapture && t.hasPointerCapture(e.pointerId)) { down = null; return; }
                dragging = true;
                try { el.setPointerCapture(e.pointerId); } catch (err) {}
                el.style.userSelect = 'none';
                el.style.cursor = 'grabbing';
                var selection = window.getSelection();
                if (selection) selection.removeAllRanges();
            }
            e.preventDefault();
            el.scrollLeft = down.left - dx;
        };
        var onUp = function(e) { if (down && e.pointerId === down.id) end(); };
        var onClick = function(e) {
            if (!swallowClick || e.detail === 0) return;
            swallowClick = false;
            e.preventDefault();
            e.stopPropagation();
        };
        var onDragStart = function(e) {
            if (down && !(e.target.closest && e.target.closest('[draggable="true"]'))) e.preventDefault();
        };
        el.addEventListener('pointerenter', onEnter);
        el.addEventListener('pointerdown', onDown);
        el.addEventListener('pointermove', onMove);
        el.addEventListener('pointerup', onUp);
        el.addEventListener('pointercancel', onUp);
        el.addEventListener('click', onClick, true);
        el.addEventListener('dragstart', onDragStart);
        return function() {
            el.removeEventListener('pointerenter', onEnter);
            el.removeEventListener('pointerdown', onDown);
            el.removeEventListener('pointermove', onMove);
            el.removeEventListener('pointerup', onUp);
            el.removeEventListener('pointercancel', onUp);
            el.removeEventListener('click', onClick, true);
            el.removeEventListener('dragstart', onDragStart);
            el.style.userSelect = '';
            el.style.cursor = '';
        };
    },
    'de.keesolutions.kcx.ui.primitives.jsViewportAtLeast' : (px) => window.matchMedia('(min-width: ' + px + 'px)').matches,
    'de.keesolutions.kcx.ui.primitives.jsOnViewportCrossing' : (px, onChange) => {
        var query = window.matchMedia('(min-width: ' + px + 'px)');
        var handler = function() { onChange(); };
        query.addEventListener('change', handler);
        return function() { query.removeEventListener('change', handler); };
    },
    'de.keesolutions.kcx.ui.primitives.JsVoidCallback' : (invoke) => () => invoke(),
    'de.keesolutions.kcx.ui.primitives.jsObserveElementSize' : (id, callback) => {
        var el = document.getElementById(id);
        if (!el) return null;
        var observer = new ResizeObserver(function(entries) {
            var r = entries[entries.length - 1].contentRect;
            callback(r.width, r.height);
        });
        observer.observe(el);
        return observer;
    },
    'de.keesolutions.kcx.ui.primitives.JsSizeCallback' : (invoke) => (width, height) => invoke(width, height),
    'de.keesolutions.kcx.ui.primitives.jsDisconnectObserver' : (observer) => { observer.disconnect(); },
    'de.keesolutions.kcx.ui.primitives.jsRegisterVoidCallback' : (id, callback) => { window['__callback_' + id] = callback; },
    'de.keesolutions.kcx.ui.primitives.JsStringCallback' : (invoke) => (str) => invoke(str),
    'de.keesolutions.kcx.ui.primitives.jsRegisterSearchCallback' : (id, callback) => { window['__search_callback_' + id] = callback; },
    'de.keesolutions.kcx.ui.primitives.JsFilePickerCallback' : (invoke) => (picked, results) => invoke(picked, results),
    'de.keesolutions.kcx.ui.primitives.jsArrayLength' : (results) => results.length,
    'de.keesolutions.kcx.ui.primitives.jsArrayGet' : (results, index) => results[index],
    'de.keesolutions.kcx.ui.primitives.jsGetName' : (obj) => obj.name,
    'de.keesolutions.kcx.ui.primitives.jsGetSize' : (obj) => obj.size,
    'de.keesolutions.kcx.ui.primitives.jsGetMimeType' : (obj) => obj.mimeType,
    'de.keesolutions.kcx.ui.primitives.jsGetBytes' : (obj) => obj.bytes,
    'de.keesolutions.kcx.ui.primitives.jsBytesLength' : (arr) => arr.length,
    'de.keesolutions.kcx.ui.primitives.jsByteAt' : (arr, i) => arr[i],
    'de.keesolutions.kcx.ui.primitives.jsLaunchFilePicker' : (accept, multiple, maxFiles, callback) => {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = accept;
        if (multiple) input.multiple = true;
        input.style.display = 'none';
        document.body.appendChild(input);
        input.addEventListener('change', function() {
            var files = input.files;
            if (!files || files.length === 0) { input.remove(); return; }
            var count = Math.min(files.length, maxFiles);
            var results = [];
            function readNext(idx) {
                if (idx >= count) { input.remove(); callback(count, results); return; }
                var file = files[idx];
                var reader = new FileReader();
                reader.onload = function(e) {
                    var bytes = new Int8Array(e.target.result);
                    results.push({
                        name: file.name,
                        size: file.size,
                        mimeType: file.type || 'application/octet-stream',
                        bytes: Array.from(bytes)
                    });
                    readNext(idx + 1);
                };
                reader.onerror = function() {
                    // Dropped from the selection with nothing else reporting it; by index,
                    // never file.name (freiham365#815). Plain console.error: this runs in
                    // the JS glue, outside KcxLog's reach, so it carries the prefix itself.
                    console.error('[E][FPICKER-WASM] FileReader failed for file[' + idx + ']; dropping it from the selection: ' + reader.error);
                    readNext(idx + 1);
                };
                reader.readAsArrayBuffer(file);
            }
            readNext(0);
        });
        input.click();
    },
    'de.keesolutions.kcx.ui.primitives.jsSetInputValue' : (element, value) => { if (element) element.value = value; },
    'de.keesolutions.kcx.ui.primitives.jsGetInputValue' : (element) => element && typeof element.value === 'string' ? element.value : '',
    'de.keesolutions.kcx.ui.primitives.jsMoveFocusInto' : (id) => {
        var prior = document.activeElement;
        var frame = 0;
        var attempt = function(retries) {
            frame = 0;
            var el = document.getElementById(id);
            if (!el) {
                if (retries > 0) frame = requestAnimationFrame(function() { attempt(retries - 1); });
                return;
            }
            if (!el.contains(document.activeElement)) el.focus({ preventScroll: true });
        };
        attempt(2);
        return function() {
            if (frame) cancelAnimationFrame(frame);
            var el = document.getElementById(id);
            var active = document.activeElement;
            var focusLeftWithIt = !active || active === document.body || (el !== null && el.contains(active));
            if (focusLeftWithIt && prior && prior !== document.body && prior.isConnected && typeof prior.focus === 'function') {
                prior.focus({ preventScroll: true });
            }
        };
    },
    'de.keesolutions.kcx.ui.primitives.jsFocusInputElement' : (el) => {
        var attempt = function(retries) {
            if (!el) return;
            if (!el.isConnected) {
                if (retries > 0) requestAnimationFrame(function() { attempt(retries - 1); });
                return;
            }
            el.focus({ preventScroll: true });
        };
        attempt(2);
    },
    'de.keesolutions.kcx.ui.primitives.jsAddDocumentEscapeListener' : (onEscape) => {
        var handler = function(e) {
            if (e.key !== 'Escape' || e.defaultPrevented || e.isComposing || e.repeat) return;
            e.preventDefault();
            onEscape();
        };
        document.addEventListener('keydown', handler);
        return function() { document.removeEventListener('keydown', handler); };
    },
    'de.keesolutions.kcx.ui.primitives.jsLockDocumentScroll' : () => {
        var root = document.documentElement;
        var overflow = root.style.getPropertyValue('overflow');
        var gutter = root.style.getPropertyValue('scrollbar-gutter');
        var scrollbar = window.innerWidth > root.clientWidth;
        root.style.setProperty('overflow', 'hidden');
        if (scrollbar) root.style.setProperty('scrollbar-gutter', 'stable');
        return function() {
            root.style.setProperty('overflow', overflow);
            root.style.setProperty('scrollbar-gutter', gutter);
        };
    },
    'de.keesolutions.kcx.ui.primitives.jsMakeOutsideInert' : (id) => {
        var changed = [];
        var frame = 0;
        var attempt = function(retries) {
            frame = 0;
            var el = document.getElementById(id);
            if (!el) {
                if (retries > 0) frame = requestAnimationFrame(function() { attempt(retries - 1); });
                return;
            }
            for (var node = el; node !== document.body && node.parentElement; node = node.parentElement) {
                var siblings = node.parentElement.children;
                for (var i = 0; i < siblings.length; i++) {
                    var sibling = siblings[i];
                    if (sibling !== node && !sibling.hasAttribute('inert')) {
                        sibling.setAttribute('inert', '');
                        changed.push(sibling);
                    }
                }
            }
        };
        attempt(2);
        return function() {
            if (frame) cancelAnimationFrame(frame);
            for (var i = 0; i < changed.length; i++) changed[i].removeAttribute('inert');
            changed = [];
        };
    },
    'de.keesolutions.kcx.ui.primitives.jsEnsureGlobalStyle' : (id, css) => {
        if (document.getElementById(id)) return;
        var s = document.createElement('style');
        s.id = id;
        s.textContent = css;
        document.head.appendChild(s);
    },
    'de.keesolutions.kcx.ui.primitives.jsLazyColumnLoadedRows' : (id) => {
        var el = document.getElementById(id);
        if (!el) return -1;
        var rows = el.firstElementChild;
        if (!rows) return 0;
        var n = rows.children.length, last = rows.lastElementChild;
        if (last && last.classList.contains('f-lazy-column-sentinel')) n--;
        return n;
    },
    'de.keesolutions.kcx.ui.primitives.jsLazyColumnScrollToEnd' : (id) => {
        var el = document.getElementById(id);
        if (!el) return;
        if (el.scrollHeight > el.clientHeight) { el.scrollTo({ top: el.scrollHeight, behavior: 'instant' }); return; }
        var rows = el.firstElementChild, last = rows && rows.lastElementChild;
        if (last) last.scrollIntoView({ block: 'end', behavior: 'instant' });
    },
    'de.keesolutions.kcx.ui.primitives.jsLazyColumnScrollToRow' : (id, index) => {
        var el = document.getElementById(id);
        var rows = el && el.firstElementChild;
        var row = rows && rows.children[index];
        if (!row || row.classList.contains('f-lazy-column-sentinel')) return NaN;
        var distance;
        if (el.scrollHeight > el.clientHeight) {
            distance = row.getBoundingClientRect().top - (el.getBoundingClientRect().top + el.clientTop);
            el.scrollBy({ top: distance, behavior: 'instant' });
        } else {
            distance = row.getBoundingClientRect().top;
            row.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
        return distance;
    },
    'de.keesolutions.kcx.gallery.JsKeyCallback' : (callback) => (event) => callback(event.key),
    'de.keesolutions.kcx.gallery.jsAddKeyListener' : (handler) => { document.addEventListener('keydown', handler); },
    'de.keesolutions.kcx.gallery.jsRemoveKeyListener' : (handler) => { document.removeEventListener('keydown', handler); },
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'de.keesolutions.freiham365.auth.data.storage.jsSetItem' : (key, value) => sessionStorage.setItem(key, value),
    'de.keesolutions.freiham365.auth.data.storage.jsGetItem' : (key) => sessionStorage.getItem(key),
    'de.keesolutions.freiham365.auth.data.storage.jsRemoveItem' : (key) => sessionStorage.removeItem(key),
    'de.keesolutions.freiham365.auth.data.storage.jsSetItem_1' : (key, value) => localStorage.setItem(key, value),
    'de.keesolutions.freiham365.auth.data.storage.jsGetItem_1' : (key) => localStorage.getItem(key),
    'de.keesolutions.freiham365.auth.data.storage.jsRemoveItem_1' : (key) => localStorage.removeItem(key),
    'de.keesolutions.freiham365.config.jsGetAppConfig' : (key) => {
        try { var c = window.__APP_CONFIG__; return c && c[key] !== undefined && c[key] !== null ? String(c[key]) : null; }
        catch(e) { return null; }
    },
    'de.keesolutions.freiham365.i18n.fetchAsBinaryString' : (url) => window.fetch(url).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status + ' for ' + url); return r.arrayBuffer(); }).then(b => { const u = new Uint8Array(b); let s = ''; for (let i = 0; i < u.length; i += 0x8000) s += String.fromCharCode.apply(null, u.subarray(i, i + 0x8000)); return s; }),
    'de.keesolutions.freiham365.settings.jsSetItem' : (key, value) => localStorage.setItem(key, value),
    'de.keesolutions.freiham365.settings.jsGetItem' : (key) => localStorage.getItem(key),
    'de.keesolutions.freiham365.settings.jsRemoveItem' : (key) => localStorage.removeItem(key),
    'de.keesolutions.freiham365.settings.jsSetItem_1' : (key, value) => localStorage.setItem(key, value),
    'de.keesolutions.freiham365.settings.jsGetItem_1' : (key) => localStorage.getItem(key),
    'de.keesolutions.freiham365.settings.jsSetItem_2' : (key, value) => localStorage.setItem(key, value),
    'de.keesolutions.freiham365.settings.jsGetItem_2' : (key) => localStorage.getItem(key),
    'de.keesolutions.freiham365.settings.jsSetItem_3' : (key, value) => localStorage.setItem(key, value),
    'de.keesolutions.freiham365.settings.jsGetItem_3' : (key) => localStorage.getItem(key),
    'de.keesolutions.freiham365.util.jsGetLocationSearch' : () => window.location.search,
    'de.keesolutions.freiham365.util.jsGetQueryParameter' : (name) => new URLSearchParams(window.location.search).get(name),
    'de.keesolutions.freiham365.util.jsGetHashQueryParameter' : (name) => {
        const hash = window.location.hash;
        const queryIndex = hash.indexOf('?');
        if (queryIndex === -1) return null;
        const queryString = hash.substring(queryIndex);
        return new URLSearchParams(queryString).get(name);
    },
    'de.keesolutions.freiham365.util.jsGetLocationHref' : () => window.location.href,
    'de.keesolutions.freiham365.util.jsReplaceHistoryState' : (url) => window.history.replaceState(window.history.state, '', url),
    'de.keesolutions.freiham365.util.jsNavigateTo' : (url) => { window.location.href = url; },
    'de.keesolutions.freiham365.util.jsNavigateToPath' : (path, depth) => { window.history.pushState({ appDepth: depth, appFrom: window.location.pathname }, '', path); window.dispatchEvent(new PopStateEvent('popstate')); },
    'de.keesolutions.freiham365.util.jsReplaceCurrentPath' : (path, depth) => { var s = window.history.state; window.history.replaceState({ appDepth: depth, appFrom: s ? s.appFrom : null }, '', path); window.dispatchEvent(new PopStateEvent('popstate')); },
    'de.keesolutions.freiham365.util.jsCurrentHistoryDepth' : () => { var s = window.history.state; return s && typeof s.appDepth === 'number' ? s.appDepth : 0; },
    'de.keesolutions.freiham365.util.jsPathBeneath' : () => { var s = window.history.state; return s && s.appFrom ? s.appFrom : null; },
    'de.keesolutions.freiham365.util.jsHistoryEntryKey' : () => {
        var s = window.history.state;
        if (s && typeof s.entryKey === 'string') return s.entryKey;
        var k = Math.random().toString(36).slice(2) + Date.now().toString(36);
        window.history.replaceState(Object.assign({}, s || {}, { entryKey: k }), '', window.location.href);
        return k;
    },
    'de.keesolutions.freiham365.util.jsReadScrollAnchor' : (prefix) => {
        const scrollerOf = (el) => {
            for (let p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
                const oy = getComputedStyle(p).overflowY;
                if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) return p;
            }
            return null;
        };
        const els = document.querySelectorAll('[id^="' + prefix + '"]');
        let edge = null;
        for (const el of els) {
            const r = (el.firstElementChild || el).getBoundingClientRect();
            if (r.width === 0) continue;
            if (edge === null) { const sc = scrollerOf(el); edge = sc ? sc.getBoundingClientRect().top : 0; }
            if (r.bottom > edge + 1) return el.id.substring(prefix.length) + '|' + Math.round(edge - r.top);
        }
        return null;
    },
    'de.keesolutions.freiham365.util.jsRestoreScrollAnchor' : (prefix, key, offset) => {
        const scrollerOf = (el) => {
            for (let p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
                const oy = getComputedStyle(p).overflowY;
                if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) return p;
            }
            return null;
        };
        const apply = () => {
            for (const el of document.querySelectorAll('[id="' + prefix + key + '"]')) {
                if (!el.isConnected) continue;
                const r = (el.firstElementChild || el).getBoundingClientRect();
                if (r.width === 0) continue;
                const sc = scrollerOf(el);
                const delta = r.top - (sc ? sc.getBoundingClientRect().top : 0) + offset;
                if (sc) sc.scrollTop += delta; else window.scrollBy(0, delta);
                return;
            }
        };
        apply();
        requestAnimationFrame(() => { apply(); setTimeout(apply, 150); });
    },
    'de.keesolutions.freiham365.util.jsObserveScroll' : (callback) => {
        let ticking = false;
        const handler = () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; callback(); }); } };
        document.addEventListener('scroll', handler, { capture: true, passive: true });
        return handler;
    },
    'de.keesolutions.freiham365.util.jsCancelObserveScroll' : (handler) => document.removeEventListener('scroll', handler, { capture: true }),
    'de.keesolutions.freiham365.util.jsOpenInNewTab' : (url) => { window.open(url, '_blank', 'noopener'); },
    'de.keesolutions.freiham365.util.jsGetLocationHostname' : () => window.location.hostname,
    'de.keesolutions.freiham365.util.jsGetLocationProtocol' : () => window.location.protocol,
    'de.keesolutions.freiham365.util.jsGetLocationPort' : () => window.location.port,
    'de.keesolutions.freiham365.util.jsSetTimeout' : (delayMs, callback) => { window.setTimeout(() => callback(), delayMs); },
    'de.keesolutions.freiham365.util.JsCallback' : (invoke) => invoke,
    'de.keesolutions.freiham365.util.jsAfterNextPaint' : (cb) => { requestAnimationFrame(() => setTimeout(cb, 0)); },
    'de.keesolutions.freiham365.util.jsAfterIdle' : (ms, cb) => { if (typeof requestIdleCallback === 'function') requestIdleCallback(() => cb(), { timeout: ms }); else setTimeout(cb, ms); },
    'de.keesolutions.freiham365.util.jsWhenDocumentParsed' : (cb) => { if (document.readyState !== 'loading') cb(); else document.addEventListener('DOMContentLoaded', () => cb(), { once: true }); },
    'de.keesolutions.freiham365.util.jsInNewTask' : (cb) => { const ch = new MessageChannel(); ch.port1.onmessage = () => { ch.port1.onmessage = null; cb(); }; ch.port2.postMessage(null); },
    'de.keesolutions.freiham365.util.jsScrollFirstElementIntoViewByClass' : (cls) => {
        var els = document.getElementsByClassName(cls);
        for (var i = 0; i < els.length; i++) {
            var rect = els[i].getBoundingClientRect();
            if (rect.width > 0) {
                els[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
        }
    },
    'de.keesolutions.freiham365.util.jsCenterScrollItemInParent' : (id) => {
        var el = document.getElementById(id);
        if (!el) return;
        var parent = el.parentElement;
        while (parent && parent !== document.body) {
            var style = window.getComputedStyle(parent);
            var overflowY = style.overflowY;
            if ((overflowY === 'auto' || overflowY === 'scroll') && parent.scrollHeight > parent.clientHeight) {
                break;
            }
            parent = parent.parentElement;
        }
        if (!parent || parent === document.body) return;
        var parentRect = parent.getBoundingClientRect();
        var elRect = el.getBoundingClientRect();
        var relativeTop = (elRect.top - parentRect.top) + parent.scrollTop;
        parent.scrollTop = relativeTop - parent.clientHeight/2 + el.clientHeight/2;
    },
    'de.keesolutions.freiham365.util.jsObserveTopVisibleSection' : (prefix, topOffset, bottomThreshold, callback) => {
        const sel = '[id^="' + prefix + '"]';
        const scrollerOf = (el) => {
            for (let p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
                const oy = getComputedStyle(p).overflowY;
                if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) return p;
            }
            return null;
        };
        const compute = () => {
            const shown = [...document.querySelectorAll(sel)].filter(el => el.getBoundingClientRect().width > 0);
            const sc = shown.length ? scrollerOf(shown[0]) : null;
            const edge = sc ? sc.getBoundingClientRect().top : 0;
            const atBottom = sc
                ? sc.scrollTop + sc.clientHeight >= sc.scrollHeight - bottomThreshold
                : window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - bottomThreshold;
            let id = '';
            for (const el of shown) if (atBottom || el.getBoundingClientRect().top - edge <= topOffset) id = el.id;
            callback(id);
        };
        const obs = { active: true, ticking: false, handler: null };
        obs.handler = (e) => {
            if (!obs.active || obs.ticking) return;
            const t = e.target;
            if (t instanceof Element && !t.querySelector(sel)) return;
            obs.ticking = true;
            requestAnimationFrame(() => { obs.ticking = false; if (obs.active) compute(); });
        };
        document.addEventListener('scroll', obs.handler, { capture: true, passive: true });
        // The first reading waits for the list's first paint: measuring the cards the same task
        // inserted forced their whole layout into that task (#1059).
        requestAnimationFrame(() => setTimeout(() => { if (obs.active) compute(); }, 0));
        return obs;
    },
    'de.keesolutions.freiham365.util.jsCancelTopVisibleSection' : (obs) => {
        obs.active = false;
        document.removeEventListener('scroll', obs.handler, { capture: true });
    },
    'de.keesolutions.freiham365.util.jsObserveScrollContainerSections' : (containerId, prefix, topOffset, callback) => {
        const c = document.getElementById(containerId);
        if (!c) return;
        const store = window.__fSectionScrollObs || (window.__fSectionScrollObs = {});
        const obs = { el: c, handler: null, active: true };
        let ticking = false;
        const compute = () => {
            const els = c.querySelectorAll('[id^="' + prefix + '"]');
            const atEnd = c.scrollTop > 0 && c.scrollTop + c.clientHeight >= c.scrollHeight - 2;
            const cTop = c.getBoundingClientRect().top;
            let id = '';
            for (let i = 0; i < els.length; i++) {
                const r = els[i].getBoundingClientRect();
                if (r.width === 0) continue;
                if (atEnd || r.top - cTop <= topOffset) id = els[i].id;
            }
            callback(id);
        };
        obs.handler = () => {
            if (!obs.active || ticking) return;
            ticking = true;
            requestAnimationFrame(() => { ticking = false; if (obs.active) compute(); });
        };
        store[containerId] = obs;
        c.addEventListener('scroll', obs.handler, { passive: true });
        compute();
    },
    'de.keesolutions.freiham365.util.jsCancelScrollContainerSections' : (containerId) => {
        const store = window.__fSectionScrollObs;
        const obs = store && store[containerId];
        if (!obs) return;
        obs.active = false;
        obs.el.removeEventListener('scroll', obs.handler);
        delete store[containerId];
    },
    'de.keesolutions.freiham365.util.jsScrollContainerToElement' : (containerId, elementId, topOffset) => {
        const c = document.getElementById(containerId);
        const el = document.getElementById(elementId);
        if (!c || !el) return;
        const top = el.getBoundingClientRect().top - c.getBoundingClientRect().top + c.scrollTop - topOffset;
        c.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    },
    'de.keesolutions.freiham365.util.jsScrollContainerTop' : (containerId) => { const c = document.getElementById(containerId); return c ? Math.round(c.scrollTop) : -1; },
    'de.keesolutions.freiham365.util.jsClearElementContent' : (elementId) => { var el = document.getElementById(elementId); if (el) el.innerHTML = ''; },
    'de.keesolutions.freiham365.util.jsIsPrerendered' : () => document.querySelector("meta[name='prerendered']") !== null,
    'de.keesolutions.freiham365.util.jsReadElementText' : (elementId) => { var el = document.getElementById(elementId); return el ? el.textContent : null; },
    'de.keesolutions.freiham365.util.jsRemoveSsgRoot' : () => { var s = document.getElementById('ssg-root'); if (s) requestAnimationFrame(function() { s.remove(); }); },
    'de.keesolutions.freiham365.util.jsGetInputValue' : (element) => element && typeof element.value === 'string' ? element.value : '',
    'de.keesolutions.freiham365.util.jsSetInputValue' : (element, value) => { if (element) element.value = value; },
    'de.keesolutions.freiham365.util.jsGetLocationPathname' : () => window.location.pathname,
    'de.keesolutions.freiham365.util.jsDecodeURIComponent' : (encoded) => decodeURIComponent(encoded),
    'de.keesolutions.freiham365.util.jsRegisterSearchCallback' : (id, callback) => { window['__search_callback_' + id] = callback; },
    'de.keesolutions.freiham365.util.JsStringCallback' : (invoke) => (str) => invoke(str),
    'de.keesolutions.freiham365.util.jsGetInputValueById' : (id) => { var el = document.getElementById(id); return el && typeof el.value === 'string' ? el.value : ''; },
    'de.keesolutions.freiham365.util.jsClearInputById' : (id) => { var el = document.getElementById(id); if (el) el.value = ''; },
    'de.keesolutions.freiham365.util.jsGoBack' : () => { window.history.back(); },
    'de.keesolutions.freiham365.util.jsAddPopStateListener' : (callback) => { window.addEventListener('popstate', () => callback()); },
    'de.keesolutions.freiham365.util.jsRegisterVisibilityChangeListener' : (callback) => { document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') callback(); }); },
    'de.keesolutions.freiham365.util.jsRegisterStorageChangeListener' : (key, callback) => { window.addEventListener('storage', (e) => { if (e.storageArea === localStorage && (e.key === null || e.key === key)) callback(); }); },
    'de.keesolutions.freiham365.util.jsIsDocumentVisible' : () => document.visibilityState !== 'hidden',
    'de.keesolutions.freiham365.util.jsObserveDocumentVisibility' : (onVisible, onHidden) => {
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') onHidden(); else onVisible();
        });
    },
    'de.keesolutions.freiham365.util.jsEncodeURIComponent' : (value) => encodeURIComponent(value),
    'de.keesolutions.freiham365.util.jsAddClass' : (elementId, className) => { var el = document.getElementById(elementId); if (el) el.classList.add(className); },
    'de.keesolutions.freiham365.util.jsRemoveClass' : (elementId, className) => { var el = document.getElementById(elementId); if (el) el.classList.remove(className); },
    'de.keesolutions.freiham365.util.jsFocusElement' : (elementId) => { var el = document.getElementById(elementId); if (el) el.focus(); },
    'de.keesolutions.freiham365.util.jsRegisterVoidCallback' : (id, callback) => { window['__callback_' + id] = callback; },
    'de.keesolutions.freiham365.util.JsVoidCallback' : (invoke) => () => invoke(),
    'de.keesolutions.freiham365.util.jsSetDarkModeClass' : (isDark) => { if (isDark) { document.documentElement.classList.add('dark'); } else { document.documentElement.classList.remove('dark'); } },
    'de.keesolutions.freiham365.util.jsSetRootCssVariable' : (name, value) => document.documentElement.style.setProperty(name, value),
    'de.keesolutions.freiham365.util.jsGetCurrentYear' : () => new Date().getFullYear(),
    'de.keesolutions.freiham365.util.jsGetUserAgent' : () => navigator.userAgent,
    'de.keesolutions.freiham365.util.jsDetectSystemDarkMode' : () => window.matchMedia('(prefers-color-scheme: dark)').matches,
    'de.keesolutions.freiham365.util.jsShowToast' : (message, accent) => {
        var toast = document.createElement('div');
        toast.textContent = message;
        toast.style.cssText = 'position:fixed;bottom:100px;left:50%;transform:translateX(-50%);background:#333537;color:#E3E2E6;padding:12px 20px;border-radius:5px;border-left:4px solid ' + accent + ';box-shadow:0 4px 16px rgba(0,0,0,0.35);font-size:14px;line-height:1.35;z-index:9999;opacity:0;transition:opacity 0.3s ease;pointer-events:none;max-width:min(90vw,520px);text-align:left;';
        document.body.appendChild(toast);
        setTimeout(function() { toast.style.opacity = '1'; }, 10);
        setTimeout(function() { toast.style.opacity = '0'; setTimeout(function() { toast.remove(); }, 300); }, 2500);
    },
    'de.keesolutions.freiham365.util.jsGetLocalStorage' : (key) => { try { return localStorage.getItem(key); } catch(e) { return null; } },
    'de.keesolutions.freiham365.util.jsSetLocalStorage' : (key, value) => { try { localStorage.setItem(key, value); } catch(e) {} },
    'de.keesolutions.freiham365.util.jsGetSessionStorage' : (key) => { try { return sessionStorage.getItem(key); } catch(e) { return null; } },
    'de.keesolutions.freiham365.util.jsSetSessionStorage' : (key, value) => { try { sessionStorage.setItem(key, value); } catch(e) {} },
    'de.keesolutions.freiham365.util.jsRemoveSessionStorage' : (key) => { try { sessionStorage.removeItem(key); } catch(e) {} },
    'de.keesolutions.freiham365.util.jsInjectScript' : (src, async) => { var s = document.createElement('script'); s.src = src; s.async = async; document.head.appendChild(s); },
    'de.keesolutions.freiham365.util.jsEvalCode' : (code) => { eval(code); },
    'de.keesolutions.freiham365.util.jsGtagPageView' : (path) => { if (window.gtag) window.gtag('event', 'page_view', { page_path: path }); },
    'de.keesolutions.freiham365.util.jsWriteClipboard' : 
        (content, fail) => {
            if (!navigator.clipboard) {
                fail('clipboard unavailable (insecure context?)');
                return;
            }
            navigator.clipboard.writeText(content).catch((e) => {
                fail(e && e.name ? e.name + ': ' + e.message : String(e));
            });
        }
        ,
    'de.keesolutions.freiham365.util.jsPushIsSupported' : () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window,
    'de.keesolutions.freiham365.util.jsPushPermissionGranted' : () => 'Notification' in window && Notification.permission === 'granted',
    'de.keesolutions.freiham365.util.jsPushSubscribe' : (vapidKey, onSuccess, onError) => {
        var b64ToU8 = function(b64) {
            var pad = '='.repeat((4 - b64.length % 4) % 4);
            var base = (b64 + pad).replace(/-/g, '+').replace(/_/g, '/');
            var raw = atob(base);
            var arr = new Uint8Array(raw.length);
            for (var i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
            return arr;
        };
        Notification.requestPermission().then(function(perm) {
            if (perm !== 'granted') { onError('denied'); return; }
            navigator.serviceWorker.register('/push-sw.js')
                .then(function() { return navigator.serviceWorker.ready; })
                .then(function(reg) {
                    return reg.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: b64ToU8(vapidKey)
                    });
                })
                .then(function(sub) { onSuccess(JSON.stringify(sub)); })
                .catch(function(e) { onError(String(e)); });
        }, function(e) { onError(String(e)); });
    },
    'de.keesolutions.freiham365.util.jsPushUnsubscribe' : (onDone) => {
        if (!('serviceWorker' in navigator)) { onDone(false); return; }
        navigator.serviceWorker.getRegistration('/push-sw.js')
            .then(function(reg) { return reg ? reg.pushManager.getSubscription() : null; })
            .then(function(sub) { return sub ? sub.unsubscribe() : false; })
            .then(function(ok) { onDone(!!ok); })
            .catch(function() { onDone(false); });
    },
    'de.keesolutions.freiham365.util.jsPushUserAgent' : () => navigator.userAgent,
    'de.keesolutions.freiham365.util.jsIsQrDecoderLoaded' : () => typeof window.jsQR === 'function',
    'de.keesolutions.freiham365.util.jsQrCameraStart' : (video, onReady, onError) => {
        if (!video || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            onError();
            return;
        }
        video.muted = true;
        video.setAttribute('playsinline', '');
        navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: false })
            .then(function(stream) { video.srcObject = stream; return video.play(); })
            .then(function() { onReady(); })
            .catch(function(e) { onError(); });
    },
    'de.keesolutions.freiham365.util.jsQrCameraStop' : (video) => {
        if (!video) return;
        var stream = video.srcObject;
        if (stream) stream.getTracks().forEach(function(t) { t.stop(); });
        video.srcObject = null;
    },
    'de.keesolutions.freiham365.util.jsQrDecodeFrame' : (video) => {
        if (!video || video.readyState < 2 || typeof window.jsQR !== 'function') return null;
        var w = video.videoWidth, h = video.videoHeight;
        if (!w || !h) return null;
        var scale = Math.min(1, 640 / Math.max(w, h));
        var cw = Math.round(w * scale), ch = Math.round(h * scale);
        var canvas = video.__qrCanvas || (video.__qrCanvas = document.createElement('canvas'));
        if (canvas.width !== cw) canvas.width = cw;
        if (canvas.height !== ch) canvas.height = ch;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) return null;
        ctx.drawImage(video, 0, 0, cw, ch);
        var data = ctx.getImageData(0, 0, cw, ch);
        var result = window.jsQR(data.data, cw, ch, { inversionAttempts: 'dontInvert' });
        return result && result.data ? result.data : null;
    },
    'de.keesolutions.freiham365.util.jsShare' : 
        (title, text, url, fail, failClipboard) => {
            if (!navigator.share) {
                if (!navigator.clipboard) {
                    failClipboard('clipboard unavailable (insecure context?)');
                    return;
                }
                navigator.clipboard.writeText(title + "\n" + text + "\n" + url).catch((e) => {
                    failClipboard(e && e.name ? e.name + ': ' + e.message : String(e));
                });
                return;
            }
            navigator.share({ title: title, text: text, url: url }).catch((e) => {
                if (e && e.name === 'AbortError') return;
                fail(e && e.name ? e.name + ': ' + e.message : String(e));
            });
        }
        ,
    'de.keesolutions.freiham365.util.packedTzdb' : (core) => core.ZoneRulesProvider.getTzdbData() || null,
    'de.keesolutions.freiham365.util.loadPackedTzdb' : (core, packed) => core.ZoneRulesProvider.loadTzdbData(packed),
    'de.keesolutions.freiham365.util.systemZoneId' : (core) => core.ZoneId.systemDefault().id(),
    'de.keesolutions.freiham365.util.narrowPackedTzdb' : (function (packed, ids) {
        var keep = Object.create(null);
        ids.split(',').forEach(function (id) { keep[id] = true; });
        var nameOf = function (line) { return line.substring(0, line.indexOf('|')); };
        var links = packed.links.filter(function (line) {
            return keep[line.substring(line.indexOf('|') + 1)] === true;
        });
        links.forEach(function (line) { keep[nameOf(line)] = true; });
        var zones = packed.zones.filter(function (line) { return keep[nameOf(line)] === true; });
        return { version: packed.version, zones: zones, links: links };
    }),
    'de.keesolutions.freiham365.util.JsJodaTimezoneModule_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvdGltZXpvbmU_,
    'de.keesolutions.freiham365.util.JsJodaCoreModule_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_,
    'de.keesolutions.freiham365.util.jsNavigateToUrl' : (url) => { window.location.href = url; }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
};
    